import React, { useState } from "react";
import { PermissionList } from "../types";

export default function CheckBoxes(props: {
  data: PermissionList[];
  value: string;
  range: string;
  setOperation: React.Dispatch<React.SetStateAction<string>>;

  selected: (
    value: boolean,
    index: number,
    sign: string,
    permissionId?: number
  ) => void;
  index: number;
}) {
  const { value, setOperation, selected, index, data, range } = props;

  return (
    <>
      <div className="flex items-center">
        <input
          type="checkbox"
          className="text-center h-5 w-5"
          checked={
            range === "add"
              ? data[index].add
              : range === "edit"
              ? data[index].edit
              : range === "delete"
              ? data[index].delete
              : range === "view"
              ? data[index].view
              : data[index].all
          }
          onChange={(e) => {
            selected(e.target.checked, index, range);
            setOperation("");
          }}
        />
      </div>
    </>
  );
}
